import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ParametersPathService } from "@MOSAR/mosar-dashboard-datamodel";
@Component({
  selector: "app-jsonpath",
  templateUrl: "./jsonpath.component.html",
  styleUrls: ["./jsonpath.component.scss"],
})
export class JsonpathComponent implements OnInit {
  @Input("context") context: any;
  @Input("model") model: any;
  @Input("placeholder") placeholder: any;
  @Input() disabledPaths: string[] = [];
  @Input() scenarioPossibleParameters;
  @Input() showOnlyDefined = false;
  @Output("select") select = new EventEmitter<any>();

  paths: Array<any>;

  constructor(private parameterPathService: ParametersPathService) {}

  ngOnInit() {
    let logicalParameters = [];
    if (this.context.parameters)
      logicalParameters = this.context.parameters.map((parameter) => {
        return {
          ...parameter,
          param: parameter.paramDescription,
          label: parameter?.paramDescription?.name ?? "Logical parameter",
          path: `$.parameters[?(@.id==${parameter.id})].value`,
        };
      });
    this.paths = this.parameterPathService
      .getAllParametersForSpecifiedEntities(this.context, false, ["PARAMETER"])
      .concat(logicalParameters);
  }

  compareFn(item1, item2) {
    if (item1?.includes(".value")) {
      return item1?.split(".value")[0] === item2;
    } else {
      return item1 === item2;
    }
  }
}
